// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.export-btn {
  transition: transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease;
}

.export-btn:hover {
  filter: brightness(0.85);
}

.export-btn:active {
  
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/views/pages/subscriptions/css/export-pdf.css"],"names":[],"mappings":"AAAA;EACE,0EAA0E;AAC5E;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,2BAA2B;EAC3B,0CAA0C;AAC5C","sourcesContent":[".export-btn {\r\n  transition: transform 0.15s ease, filter 0.15s ease, box-shadow 0.15s ease;\r\n}\r\n\r\n.export-btn:hover {\r\n  filter: brightness(0.85);\r\n}\r\n\r\n.export-btn:active {\r\n  \r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
